import React from "react";
import {DocType} from "@commons/mapping/UniversalDocRecord";

interface SezioneDocsBar {
    sezioneDoc: DocType,
    setSezioneSel: () => void,
    children?: React.ReactNode;
}

export const SezioneDocsBar: React.FC<SezioneDocsBar> = ({sezioneDoc, setSezioneSel, children}) => {
    return <>
        <div className={`panel-doc ${sezioneDoc} w-full flex flex-col md:flex-row rounded-lg px-4 xl:px-6 py-2 mb-5 font-medium text-xs xl:text-sm
                focus:outline-none focus-visible:ring focus-visible:ring-opacity-75`}>
            <div className="md:mr-auto">
                <div className="flex flex-row justify-center items-center">
                            <span className="max-md:hidden truncate">
                            Hai selezionato la sezione documentale&nbsp;&nbsp;<span className="uppercase">{sezioneDoc}</span>
                        </span>

                </div>
            </div>
            <div className="self-center md:ml-auto">
                <button className="md:w-64 rounded-lg bg-white py-1 px-1.5 shadow-sm hover:bg-gray-300" onClick={setSezioneSel}>
                    CAMBIA SEZIONE
                </button>
            </div>
        </div>
    </>
}
